/** @format */

export const DEFAULT_TEST_ID = 'product-out-of-stock';
